import { Component } from "@angular/core";

@Component({
  template: ``,
})
export class P302Component {
  constructor() {}
}
